import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { HomeComponent } from './home.component';
import { NeedsComponent } from './needs.component';
import { AwardsComponent } from './awards.component';
import { SponsorsComponent } from './sponsors.component';
import { ContactComponent } from './contact.component';
import { CardsComponent } from './cards.component';

import { AppRoutingModule } from './app-routing.module';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule
  ],
  declarations: [
    AppComponent,
    HomeComponent,
    NeedsComponent,
    AwardsComponent,
    SponsorsComponent,
    ContactComponent,
    CardsComponent
  ],
  providers: [],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts